import { useState } from "react"
import { XMarkIcon, InformationCircleIcon } from "@heroicons/react/24/outline"

interface InfoBannerProps {
  message: string
}

export default function InfoBanner({ message }: InfoBannerProps) {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  return (
    <div className="flex items-center gap-3 bg-system-blue-700/50 border border-system-blue-600 rounded-lg px-4 py-2 mt-4">
      <InformationCircleIcon className="w-5 h-5 text-system-gray-300 flex-shrink-0" />
      <span className="text-sm text-system-gray-300 flex-1">{message}</span>
      <button
        onClick={() => setDismissed(true)}
        className="text-system-gray-400 hover:text-white"
        aria-label="Dismiss"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  )
}
